// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"8212b41b","145":"ac406401","204":"ae464f70","260":"56c77002","453":"5d79306b","560":"af454f7f","586":"39f316a3","620":"3a9139bd","658":"0c866a48","951":"fe20947b","970":"07cfd7fa"}[chunkId] + ".chunk.js";
};